import { SpaceMd, SpaceXxs, SpaceXs } from "@nxt-costco-com/forge-design-tokens";
const warehouseIconStyles = {
  height: SpaceMd,
  width: SpaceMd
};
const warehouseWrapperStyles = {
  cursor: "default",
  display: "flex",
  flexWrap: "nowrap",
  gap: SpaceXs
};
const warehouseTextDivStyles = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: SpaceXxs
};
export {
  warehouseIconStyles,
  warehouseTextDivStyles,
  warehouseWrapperStyles
};
